"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// The auth interceptor flashes the API's message for 401, 403, 404, 409 and
// 422, but not for this one, so the webhook handlers flash it themselves.
var HTTP_BAD_GATEWAY = 502;
var AdminBillingController = /** @class */ (function () {
    function AdminBillingController(ENV, $state, PoliciesModel, SchoolsModel, FlashService, CreateOrderService, PolicyService, PoliciesStoreService, UserService) {
        this.ENV = ENV;
        this.busy = true;
        this.loading = true;
        this.webhookBusy = false;
        this.authorizeWebhookBusy = false;
        this.authorizeSignatureKey = "";
        this.schoolId = UserService.getCurrentUser().school_id;
        this.policies = {
            billing: {
                id: 0,
                policymeta: {
                    authorize_api_login_id: "",
                    authorize_api_trans_key: "",
                    authorize_api_client_key: "",
                    billing_gateway: "",
                    instructor_can_create_orders: "",
                    paypal_rest_api_client_id: "",
                    paypal_rest_api_secret_key: "",
                    paypal_rest_api_environment: "sandbox",
                    stripe_publishable_key: "",
                    stripe_secret_key: "",
                    surcharge_amount: 0,
                    surcharge_detail: "",
                    surcharge_on: "",
                },
            },
        };
        this.PoliciesModel = PoliciesModel;
        this.SchoolsModel = SchoolsModel;
        this.FlashService = FlashService;
        this.CreateOrderService = CreateOrderService;
        this.PolicyService = PolicyService;
        this.PoliciesStoreService = PoliciesStoreService;
        this.$cashier = CreateOrderService.cashier();
        var billingPolicy = PoliciesStoreService.getPolicy("billing");
        if (billingPolicy) {
            this.policies.billing.id = billingPolicy.id;
            this.policies.billing.policymeta = billingPolicy.policymeta;
        }
        this.webhookConfigured = !!this.policies.billing.policymeta
            .stripe_webhook_secret;
        this.authorizeWebhookConfigured = !!this.policies.billing.policymeta.authorize_webhook_id;
        this.authorizeCredentialsSaved = this.hasAuthorizeCredentials();
        this.busy = false;
        this.loading = false;
        this.updateInstructorsTakingOrders =
            this.updateInstructorsTakingOrders.bind(this);
    }
    AdminBillingController.prototype.updateSurcharge = function () {
        var _this = this;
        this.busy = true;
        var payload = {
            id: this.policies.billing.id,
            surcharge_on: this.policies.billing.policymeta.surcharge_on,
            surcharge_amount: this.policies.billing.policymeta.surcharge_amount,
            surcharge_detail: this.policies.billing.policymeta.surcharge_detail,
        };
        this.PoliciesModel.update(payload)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            if (_this.$cashier.policies().policyExists("billing")) {
                var billingPolicy = _this.$cashier
                    .policies()
                    .getPolicyByName("billing");
                billingPolicy.setMetaValueByKey("surcharge_on", payload.surcharge_on);
                billingPolicy.setMetaValueByKey("surcharge_amount", payload.surcharge_amount);
                billingPolicy.setMetaValueByKey("surcharge_detail", payload.surcharge_detail);
                _this.CreateOrderService.$cashier.policies().setPolicy(billingPolicy);
                _this.CreateOrderService.$cashier.setupPolicies();
            }
            _this.PoliciesStoreService.writePolicy("billing", _this.policies.billing.policymeta);
            _this.busy = false;
        })
            .catch(function (Error) {
            _this.busy = false;
        });
    };
    AdminBillingController.prototype.updateInstructorsTakingOrders = function () {
        var _this = this;
        this.busy = true;
        var payload = {
            id: this.policies.billing.id,
            instructor_can_create_orders: this.policies.billing.policymeta.instructor_can_create_orders,
        };
        this.PoliciesModel.update(payload)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            if (_this.$cashier.policies().policyExists("billing")) {
                var billingPolicy = _this.$cashier
                    .policies()
                    .getPolicyByName("billing");
                billingPolicy.setMetaValueByKey("instructor_can_create_orders", payload.instructor_can_create_orders);
                _this.CreateOrderService.$cashier.policies().setPolicy(billingPolicy);
                _this.CreateOrderService.$cashier.setupPolicies();
            }
            _this.PoliciesStoreService.writePolicy("billing", _this.policies.billing.policymeta);
            _this.busy = false;
        })
            .catch(function (Error) {
            _this.busy = false;
        });
    };
    AdminBillingController.prototype.processPolicy = function () {
        var _this = this;
        this.busy = true;
        var meta = this.policies.billing.policymeta;
        var request = {
            id: this.policies.billing.id,
            billing_gateway: meta.billing_gateway,
            authorize_api_login_id: meta.authorize_api_login_id,
            authorize_api_trans_key: meta.authorize_api_trans_key,
            authorize_api_client_key: meta.authorize_api_client_key,
            stripe_secret_key: meta.stripe_secret_key,
            stripe_publishable_key: meta.stripe_publishable_key,
            paypal_rest_api_client_id: meta.paypal_rest_api_client_id,
            paypal_rest_api_secret_key: meta.paypal_rest_api_secret_key,
            paypal_rest_api_environment: meta.paypal_rest_api_environment,
            square_access_token: meta.square_access_token,
            square_application_id: meta.square_application_id,
            square_environment: meta.square_environment,
            surcharge_on: meta.surcharge_on,
            surcharge_amount: meta.surcharge_amount,
            surcharge_detail: meta.surcharge_detail,
            instructor_can_create_orders: meta.instructor_can_create_orders,
        };
        this.PoliciesModel.update(request)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            if (_this.$cashier.policies().policyExists("billing")) {
                var billingPolicy = _this.$cashier
                    .policies()
                    .getPolicyByName("billing");
                billingPolicy.setMetaValueByKey("billing_gateway", request.billing_gateway);
                billingPolicy.setMetaValueByKey("authorize_api_client_key", request.authorize_api_client_key);
                billingPolicy.setMetaValueByKey("authorize_api_trans_key", request.authorize_api_trans_key);
                billingPolicy.setMetaValueByKey("authorize_api_login_id", request.authorize_api_login_id);
                billingPolicy.setMetaValueByKey("stripe_secret_key", request.stripe_secret_key);
                billingPolicy.setMetaValueByKey("stripe_publishable_key", request.stripe_publishable_key);
                billingPolicy.setMetaValueByKey("paypal_rest_api_client_id", request.paypal_rest_api_client_id);
                billingPolicy.setMetaValueByKey("paypal_rest_api_secret_key", request.paypal_rest_api_secret_key);
                billingPolicy.setMetaValueByKey("paypal_rest_api_environment", request.paypal_rest_api_environment);
                _this.CreateOrderService.$cashier.policies().setPolicy(billingPolicy);
                _this.CreateOrderService.$cashier.setupPolicies();
                _this.PolicyService.setPolicies(_this.CreateOrderService.$cashier.policies());
            }
            _this.PoliciesStoreService.writePolicy("billing", _this.policies.billing.policymeta);
            _this.authorizeCredentialsSaved = _this.hasAuthorizeCredentials();
            _this.busy = false;
        })
            .catch(function (Error) {
            _this.busy = false;
        });
    };
    /**
     * Drive Scout calls Stripe on the school's behalf using their saved
     * stripe_secret_key, registers the webhook endpoint, and stores the
     * returned signing secret in policymeta. Idempotent — clicking again
     * tears down any existing endpoint at our URL before creating a fresh one.
     */
    AdminBillingController.prototype.configureStripeWebhook = function () {
        var _this = this;
        this.webhookBusy = true;
        this.SchoolsModel.configureStripeWebhook(this.schoolId)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            // UI-only flag so the screen flips to the "Reconfigure / Remove"
            // state without re-fetching the policy. Deliberately NOT written
            // into policymeta or the store: a placeholder there round-trips
            // through policy saves and overwrites the real signing secret.
            _this.webhookConfigured = true;
            _this.webhookBusy = false;
        })
            .catch(function () {
            _this.webhookBusy = false;
        });
    };
    AdminBillingController.prototype.removeStripeWebhook = function () {
        var _this = this;
        this.webhookBusy = true;
        this.SchoolsModel.removeStripeWebhook(this.schoolId)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.webhookConfigured = false;
            _this.webhookBusy = false;
        })
            .catch(function () {
            _this.webhookBusy = false;
        });
    };
    /**
     * The API registers the webhook with the credentials the school has
     * *saved*, so typing them into the boxes is not enough.
     */
    AdminBillingController.prototype.hasAuthorizeCredentials = function () {
        var meta = this.policies.billing.policymeta;
        return !!(meta.authorize_api_login_id && meta.authorize_api_trans_key);
    };
    /**
     * A Signature Key is needed the first time. Once a webhook exists the API
     * reuses the stored key, so Reconfigure works with the box empty.
     */
    AdminBillingController.prototype.canConfigureAuthorizeWebhook = function () {
        if (this.authorizeWebhookBusy || !this.authorizeCredentialsSaved) {
            return false;
        }
        return (this.authorizeWebhookConfigured ||
            this.authorizeSignatureKey.trim() !== "");
    };
    /**
     * Drive Scout registers a webhook with Authorize.Net using the school's
     * saved API Login ID and Transaction Key, and stores the Signature Key
     * sent here (encrypted, write-only). The key is deliberately a local field
     * and not policymeta: the generic billing save ignores it, and the API
     * never sends it back.
     */
    AdminBillingController.prototype.configureAuthorizeWebhook = function () {
        var _this = this;
        this.authorizeWebhookBusy = true;
        var signatureKey = this.authorizeSignatureKey.trim();
        var request = signatureKey === "" ? {} : { signature_key: signatureKey };
        this.SchoolsModel.configureAuthorizeWebhook(this.schoolId, request)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.authorizeWebhookConfigured = true;
            _this.authorizeSignatureKey = "";
            _this.authorizeWebhookBusy = false;
        })
            .catch(function (response) {
            _this.flashBadGateway(response);
            _this.authorizeWebhookBusy = false;
        });
    };
    AdminBillingController.prototype.removeAuthorizeWebhook = function () {
        var _this = this;
        this.authorizeWebhookBusy = true;
        this.SchoolsModel.removeAuthorizeWebhook(this.schoolId)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.authorizeWebhookConfigured = false;
            _this.authorizeWebhookBusy = false;
        })
            .catch(function (response) {
            _this.flashBadGateway(response);
            _this.authorizeWebhookBusy = false;
        });
    };
    AdminBillingController.prototype.flashBadGateway = function (response) {
        var _a;
        if (response.status !== HTTP_BAD_GATEWAY || !((_a = response.data) === null || _a === void 0 ? void 0 : _a.message)) {
            return;
        }
        this.FlashService.setMessage({
            type: "danger",
            message: response.data.message,
        });
    };
    return AdminBillingController;
}());
AdminBillingController.$inject = [
    "ENV",
    "$state",
    "PoliciesModel",
    "SchoolsModel",
    "FlashService",
    "CreateOrderService",
    "PolicyService",
    "PoliciesStoreService",
    "UserService",
];
exports.default = AdminBillingController;
